import React from 'react';
import Header from './Header';
import MainPage from './MainPage';
import Footer from './Footer';
import './Layout.css';

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <Header />
      <MainPage>
        {children}
      </MainPage>
      <Footer />
    </div>
  );
};

export default Layout;
